const HorizontalLine = () => {
	return (
		<hr style={{
			width: "100%", color: "black"
		}}/>
	)

}
export default HorizontalLine;